import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KokuminNenkinKikin = props => {
  return <Dropdown.Static kubunKey='kokumin_nenkin_kikin_kbn' {...props} />
}
